import { BodyLarge } from '#/components/Text/BodyLarge';
import { BodySmall } from '#/components/Text/BodySmall';
import type {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockBlockquote,
} from '#/modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import { colors } from '#/theme/theme';

import { CmsSplitContentBlockquote } from './CmsSplitContentBlockquote';
import {
  CmsSplitContentBlockquoteContent_Box_1,
  CmsSplitContentBlockquoteContent_Box_2,
} from './CmsSplitContentBlockquoteContent.styled';

type Props = {
  appearance: CmsApiSplitBlockAppearance;
  blockId: string;
  section: CmsApiSplitBlockBlockquote;
  blockIndex: number;
  index: number;
};

export function CmsSplitContentBlockquoteContent({
  appearance,
  blockId,
  blockIndex,
  index,
  section,
}: Props) {
  const showTextBox = ['FULL_WIDTH', 'OVERLAPPING'].includes(appearance);
  return (
    <CmsSplitContentBlockquoteContent_Box_2
      data-qa-id={`split-content-section-${index}`}
      key={blockId}
      style={{ zIndex: showTextBox ? 1 : undefined }}
    >
      <CmsSplitContentBlockquoteContent_Box_1
        style={{
          background: showTextBox ? 'white' : colors.backgroundGrey,
          boxShadow: showTextBox ? '0 0 6px rgba(0,0,0,0.3)' : undefined,
          borderRadius: showTextBox ? 12 : 24,
        }}
      >
        <CmsSplitContentBlockquote>
          <BodyLarge
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Split Content',
              },
            }}
            dangerouslySetInnerHTML={{
              __html: section.data.quote,
            }}
          />

          {section.data.cite && <BodySmall>{section.data.cite}</BodySmall>}
        </CmsSplitContentBlockquote>
      </CmsSplitContentBlockquoteContent_Box_1>
    </CmsSplitContentBlockquoteContent_Box_2>
  );
}
